import type { AdditionalField } from 'app/store/project/addition-fields/addition-fields.reducer';
import { createAction, props } from '@ngrx/store';

export const writeAdditions = createAction('[Addition Fields Store] Write Additions', props<{ fields: AdditionalField[] }>());
